import dayjs from "dayjs";
import { LONG_DATE_TIME_FORMAT } from "fixtures/globalConstants";
import { useMemo } from "react";
import { Post } from "store/posts/postConstants";

export const usePublishDate = (
  post: Post,
  autoScheduledIndex?: number,
  autoScheduledTimes?: string[]
) => {
  return useMemo(() => {
    let publishPostDateValue: string | number | undefined = undefined;
    if (autoScheduledIndex !== undefined && autoScheduledTimes) {
      publishPostDateValue = autoScheduledTimes[autoScheduledIndex];
    } else if (post.adhoc_publish_minute_timestamp) {
      publishPostDateValue = post.adhoc_publish_minute_timestamp * 60000;
    }
    const dayjsDate = dayjs(publishPostDateValue).local();
    return {
      publishPostDate: dayjsDate,
      publishPostDateFormatted: dayjsDate?.format(LONG_DATE_TIME_FORMAT),
    };
  }, [
    autoScheduledIndex,
    autoScheduledTimes,
    post.adhoc_publish_minute_timestamp,
  ]);
};
